import {
  fallbackSchema,
  recoverConfigSchema,
  scenarioPopulatedSchema,
} from "@redotech/redo-model/recover-config";
import { objectId } from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateRecoverConfig = {
  name: "updateRecoverConfig" as const,
  input: z.object({
    id: z.string(),
    name: z.string().optional(),
    discountId: objectId().nullish(),
    agentName: z.string().optional(),
    brandName: z.string().optional(),
    supportEmail: z.string().optional(),
    scenarios: z.array(scenarioPopulatedSchema).optional(),
    fallback: fallbackSchema.optional(),
  }),
  output: recoverConfigSchema,
};
